import { Mail } from 'lucide-react'
import { useState } from 'react'
import BackButton from '../../../components/common/BackButton'
import DeleteButton from '../../../components/common/DeleteButton'
import EditButton from '../../../components/common/EditButton'
import Badge from '../../../components/ui/badge/Badge'
import { useAuth } from '../../../context/AuthContext'
import { useProfessional } from '../../../context/ProfessionalContext'
import ProfessionalForm from '../ProfessionalForm'
import ProfessionalDeactivate from './ProfessionalDeactivate'

const ProfessionalResume = () => {
    const [openEdit, setOpenEdit] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const { detail } = useProfessional()
    const { user } = useAuth()
    if (!detail) return null
    const professional = detail.professional

    return (
        <>
            <div className='flex items-center justify-between text-gray-800 dark:text-white/90'>
                <div className='space-y-1'>
                    <div className='flex items-center gap-2'>
                        <BackButton isIconOnly />
                        <h2 className='mr-1 text-xl font-bold'>{professional.name}</h2>
                        <Badge color={professional.admin ? 'primary' : 'light'}>
                            {professional.admin ? 'Administrador' : 'Profissional'}
                        </Badge>
                    </div>
                    <div className='flex items-center gap-1'>
                        <Mail className='h-4 w-4' />
                        <p>{professional.email || 'Não informado'}</p>
                    </div>
                </div>
                <div className='flex items-center gap-1'>
                    <EditButton handleClick={() => setOpenEdit(true)} />
                    <DeleteButton
                        handleClick={() => setOpenDelete(true)}
                        isDisabled={professional.id === user?.userID}
                    />
                </div>
            </div>
            <ProfessionalForm type='edit' open={openEdit} handleClose={() => setOpenEdit(false)} />
            <ProfessionalDeactivate data={detail} open={openDelete} handleClose={() => setOpenDelete(false)} />
        </>
    )
}

export default ProfessionalResume
